import React, { useEffect, useState } from "react";
import { Col, Container, Row, Form, Button, Toast } from "react-bootstrap";
import Loader from "../gif/loader.gif";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import SideBar from "../navigation/sidebar/SideBar";
import NavBar from "../navigation/topnav/NavBar";
import CardDesign from "../components/Card";
import RowTitles from "../components/RowTitles";

const Register = () => {
  const navigate = useNavigate();

  const [cardUID, setCardUID] = useState(null);
  const [readerName, setReaderName] = useState(null);
  const [name, setName] = useState();
  const [surname, setSurname] = useState();
  const [cell, setCell] = useState();
  const [email, setEmail] = useState();
  const [address, setAddrress] = useState();
  const [gender, setGender] = useState();
  const [city, setCity] = useState();
  const [country, setCountry] = useState();
  const [type, setType] = useState();
  //toast
  const [show, setShow] = useState(false);
  const [resultText, setResultText] = useState();
  const [bgclass, setBgClass] = useState();
  //loading
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setCardUID("");
    const ws = new WebSocket("ws://localhost:8080");
    //console.log(ws);

    ws.onopen = () => {
      console.log("Connected to WebSocket server");
    };

    ws.onmessage = (event) => {
      const data = JSON.parse(event.data);
      console.log(data);
      if (data.uid) {
        setCardUID(data.uid);
      }
      if (data.reader) {
        setReaderName(data.reader);
      }
    };

    ws.onerror = (error) => {
      console.error("WebSocket error:", error);
    };

    ws.onclose = () => {
      console.log("WebSocket connection closed");
    };

    return () => {
      ws.close(); // Clean up WebSocket connection when component unmounts
    };
  }, []);
  //when loggining
  const onSubmitLogin = async (e) => {
    e.preventDefault();
    setLoading(!loading);
    let data = {
      name,
      surname,
      cell,
      email,
      tagid: cardUID,
      address,
      gender,
      city,
      country,
      type,
    };
    console.log(data);
    try {
      const res = await axios.post(
        `https://ntcapi-a4fdbbdfb3gactbd.southafricanorth-01.azurewebsites.net/api/save-uid`,
        data
      );
      let retcode = res.data.message;
      //stop loading
      setLoading(false);
      //show toast
      setShow(!show);
      //configure toast
      setResultText(retcode);
      //set tast color
      setBgClass("success");
    } catch (error) {
      //stop loading
      setLoading(false);
      //show toast
      setShow(!show);
      //configure toast
      setResultText("Registration failed.. Please try again.");
      //set tast color
      setBgClass("danger");
      console.log("post error =>" + error);
    }
  };
  const goBackHome = () => {
    navigate("/");
  };
  const closeToast = () => {
    //close toast
    setName("");
    setSurname("");
    setCell("");
    setEmail("");
    setCardUID("");
    setShow(!show);
  };
  return (
    <div className="d-flex" style={{ backgroundColor: "#f1f5f7" }}>
      <SideBar />
      <div className="flex-grow-1">
        <NavBar />
        <div className="container-fluid mt-4">
          <div className="row">
            <div className="col-md-6">
              <RowTitles title={"Dashboad"} child={"Register new member"} />
              <h4 className="mb-3">New member</h4>
            </div>
            <div className="col-md-6 text-end">
              Reader:{" "}
              {readerName ? (
                <small
                  className="fw-bold"
                  style={{
                    backgroundColor: "#3cd365",
                    borderRadius: 20,
                    padding: 5,
                    fontSize: 11,
                  }}
                >
                  {readerName}
                </small>
              ) : null}
              <br />
              Card:{" "}
              {cardUID ? (
                <small
                  className="fw-bold"
                  style={{
                    backgroundColor: "#3cd365",
                    borderRadius: 20,
                    padding: 5,
                    fontSize: 11,
                  }}
                >
                  {cardUID}
                </small>
              ) : null}
            </div>
          </div>
          {/* //main container */}
          <Container className="mt-3">
            <Row className="d-flex align-items-center justify-content-center">
              <Toast
                onClose={closeToast}
                show={show}
                delay={3000}
                bg={bgclass}
                autohide
              >
                <Toast.Body className="text-white">{resultText}</Toast.Body>
              </Toast>
            </Row>
            {/* //main content container */}
            <Col md={12} sm={12}>
              {/* //main container row */}
              <Row
                style={{
                  textAlign: "left",
                  backgroundColor: "white",
                  borderRadius: 20,
                  padding: 20,
                }}
                className="d-flex align-items-center justify-content-center border border-mute"
              >
                <Col md={6} sm={12} className="p-3 text-center">
                  <CardDesign cardUID={cardUID} name={name} surname={surname} />
                </Col>
                <Col md={6} sm={12} className="text-center">
                  <h6 className="fw-light">Enter member details</h6>
                  <div
                    className="mx-auto  p-2 border rounded"
                    style={{ width: "100%" }}
                  >
                    <Form
                      className="text-center needs-validation"
                      onSubmit={onSubmitLogin}
                    >
                      <Form.Group
                        className="mb-3 was-validated w-100"
                        controlId="formBasicEmail"
                      >
                        <div className="row align-items-center mb-3">
                          <div className="col-4">
                            <Form.Label>NFC Tag identifier</Form.Label>
                          </div>
                          <div className="col">
                            <Form.Control
                              type="email"
                              className="p-2 w-100"
                              placeholder="NFC Tag identifier"
                              disabled
                              value={cardUID}
                              style={{ borderRadius: 0, fontSize: "12pt" }}
                            />
                          </div>
                        </div>
                        <div className="row align-items-center mb-3">
                          <div className="col-md-4 col-sm-12">
                            <Form.Label>First Names</Form.Label>
                          </div>
                          <div className="col-md-8 col-sm-12">
                            <Form.Control
                              type="text"
                              className="p-2"
                              placeholder="Type full name"
                              required
                              value={name}
                              disabled={cardUID ? false : true}
                              onChange={(e) => setName(e.target.value)}
                              style={{ borderRadius: 0, fontSize: "12pt" }}
                            />
                            <p className="invalid-feedback text-sm">
                              Please type member first names
                            </p>
                          </div>
                        </div>
                        <div className="row align-items-center mb-3">
                          <div className="col-md-4 col-sm-12">
                            <Form.Label>Surname</Form.Label>
                          </div>
                          <div className="col-md-8 col-sm-12">
                            <Form.Control
                              className="p-2"
                              type="text"
                              placeholder="Type surname"
                              required
                              value={surname}
                              disabled={cardUID ? false : true}
                              onChange={(e) => setSurname(e.target.value)}
                              style={{ borderRadius: 0, fontSize: "12pt" }}
                            />
                            <small className="invalid-feedback fw=bold">
                              Please type member surname
                            </small>
                          </div>
                        </div>
                        <div className="row align-items-center mb-3">
                          <div className="col-md-4 col-sm-12">
                            <Form.Label>Cell Number</Form.Label>
                          </div>
                          <div className="col-md-8 col-sm-12">
                            <Form.Control
                              className="p-2"
                              type="text"
                              placeholder="Type cell number"
                              required
                              value={cell}
                              disabled={cardUID ? false : true}
                              onChange={(e) => setCell(e.target.value)}
                              style={{ borderRadius: 0, fontSize: "12pt" }}
                            />
                            <small className="invalid-feedback fw=bold">
                              Please type member cell
                            </small>
                          </div>
                        </div>
                        <div className="row align-items-center mb-3">
                          <div className="col-md-4 col-sm-12">
                            <Form.Label>Home Address</Form.Label>
                          </div>
                          <div className="col-md-8 col-sm-12">
                            <Form.Control
                              className="p-2"
                              type="text"
                              placeholder="Type home address"
                              required
                              value={address}
                              disabled={cardUID ? false : true}
                              onChange={(e) => setAddrress(e.target.value)}
                              style={{ borderRadius: 0, fontSize: "12pt" }}
                            />
                            <small className="invalid-feedback fw=bold">
                              Please type home address
                            </small>
                          </div>
                        </div>
                        <div className="row align-items-center mb-3">
                          <div className="col-md-4 col-sm-12">
                            <Form.Label>Email Address</Form.Label>
                          </div>
                          <div className="col-md-8 col-sm-12">
                            <Form.Control
                              className="p-2"
                              type="text"
                              placeholder="Type email address"
                              required
                              value={email}
                              disabled={cardUID ? false : true}
                              onChange={(e) => setEmail(e.target.value)}
                              style={{ borderRadius: 0, fontSize: "12pt" }}
                            />
                            <small className="invalid-feedback fw=bold">
                              Please type email address
                            </small>
                          </div>
                        </div>
                        <div className="row align-items-center mb-3">
                          <div className="col-md-4 col-sm-12">
                            <Form.Label>Member Gender</Form.Label>
                          </div>
                          <div className="col-md-8 col-sm-12">
                            <select
                              class="form-control"
                              id="slgender"
                              style={{ borderRadius: 0, fontSize: "12pt" }}
                              disabled={cardUID ? false : true}
                              value={gender}
                              onChange={(e) => setGender(e.target.value)}
                            >
                              <option>Male</option>
                              <option>Female</option>
                            </select>
                          </div>
                        </div>
                        <div className="row align-items-center mb-3">
                          <div className="col-md-4 col-sm-12">
                            <Form.Label>Member City</Form.Label>
                          </div>
                          <div className="col-md-8 col-sm-12">
                            <select
                              class="form-control"
                              id="slcity"
                              disabled={cardUID ? false : true}
                              style={{ borderRadius: 0, fontSize: "12pt" }}
                              value={city}
                              onChange={(e) => setCity(e.target.value)}
                            >
                              <option>Maseru</option>
                              <option>Bloemfontein</option>
                              <option>Welkom</option>
                              <option>Kimberly</option>
                              <option>Mafikeng</option>
                              <option>Gauteng</option>
                            </select>
                            <small className="invalid-feedback fw=bold">
                              Please type home address
                            </small>
                          </div>
                        </div>
                        <div className="row align-items-center mb-3">
                          <div className="col-md-4 col-sm-12">
                            <Form.Label>Member Country</Form.Label>
                          </div>
                          <div className="col-md-8 col-sm-12">
                            <select
                              class="form-control"
                              id="slcountry"
                              disabled={cardUID ? false : true}
                              style={{ borderRadius: 0, fontSize: "12pt" }}
                              value={country}
                              onChange={(e) => setCountry(e.target.value)}
                            >
                              <option>Lesotho</option>
                              <option>South Africa</option>
                              <option>Botswana</option>
                              <option>Zimbabwe</option>
                              <option>Namibia</option>
                              <option>Eswatini</option>
                            </select>
                            <small className="invalid-feedback fw=bold">
                              Please type home address
                            </small>
                          </div>
                        </div>
                        <div className="row align-items-center mb-3">
                          <div className="col-md-4 col-sm-12">
                            <Form.Label>Member Type</Form.Label>
                          </div>
                          <div className="col-md-8 col-sm-12">
                            <select
                              class="form-control"
                              id="sltype"
                              disabled={cardUID ? false : true}
                              style={{ borderRadius: 0, fontSize: "12pt" }}
                              value={type}
                              onChange={(e) => setType(e.target.value)}
                            >
                              <option>Church Member</option>
                              <option>Scanner</option>
                              <option>Admin User</option>
                            </select>
                            <small className="invalid-feedback fw=bold">
                              Please type home address
                            </small>
                          </div>
                        </div>
                      </Form.Group>
                      {loading ? (
                        <img
                          src={Loader}
                          alt="QR Code"
                          width={"100"}
                          height={"100"}
                          className="img-fluid"
                        />
                      ) : (
                        <Button
                          className="p-3 w-100 text-dark"
                          type="submit"
                          style={{ backgroundColor: "#3bc0c3", border: "none" }}
                        >
                          Register Member
                        </Button>
                      )}
                    </Form>
                  </div>
                </Col>
              </Row>
            </Col>
          </Container>
        </div>
      </div>
    </div>
  );
};

export default Register;
